import { render } from "./OpenScreen.vue?vue&type=template&id=15cbc940&scoped=true"
import script from "./OpenScreen.vue?vue&type=script&lang=js"
export * from "./OpenScreen.vue?vue&type=script&lang=js"

import "./OpenScreen.vue?vue&type=style&index=0&id=15cbc940&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cbc940"]])

export default __exports__